import React, { useState, useEffect, useRef  } from 'react';
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import ShowError from "../shared/ShowError";
import { Col, Container, Row } from 'react-bootstrap';
import { RadioButton } from 'primereact/radiobutton';
import CityCombo from '../combos/CityCombo';

export default function GetCompanyDetailInContractRequest(props) {
    const navigate = useNavigate();
    const [isPersonal, setIsPersonal] = useState(true);
    const [personNationalId, setPersonNationalId] = useState("");
    const [economicCode, setEconomicCode] = useState("");
    const [companyNationalId, setCompanyNationalId] = useState("");
    const [title, setTitle] = useState("");
    const [city, setCity] = useState(null);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const targetRef1 = useRef(null);

    useEffect(() => {
        util.scrollToElement(targetRef1, "start");
        var bc = util.getBuyCompany();
        var osd = util.getOtherSystemDetail();
        console.log("osd is>", osd)
        if(bc != null){
            if(bc.title == ""){
                bc.title = osd.companyTitle;
            }
            setIsPersonal(bc.isPersonal);
            setPersonNationalId(bc.personNationalId);
            setEconomicCode(bc.economicCode);
            setCompanyNationalId(bc.companyNationalId);
            setTitle(bc.title);
            setCity(bc.city);
        }
        else{
            setTitle(osd.companyTitle);
        }
    }, []);
    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "personNationalId") setPersonNationalId(val);
        else if(name === "economicCode") setEconomicCode(val);
        else if(name === "companyNationalId") setCompanyNationalId(val);
        else if(name === "title") setTitle(val);
    }
    const checkDataEntry = function(){
        if(title.trim().length < 3){
            setErrorMessage("نام شرکت، موسسه یا فروشگاه را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(isPersonal){
            if(personNationalId.trim().length < 1){
                setErrorMessage("کد ملی را وارد کنید");
                setErorVisible(true);
                return false;
            }
            if(personNationalId.trim().length < 10){
                setErrorMessage("کد ملی معتبر نمی باشد");
                setErorVisible(true);
                return false;
            }
            if((personNationalId.trim().length == 10)&&(!util.IsValidNationalCode(personNationalId))){
                setErrorMessage("کد ملی معتبر نمی باشد");
                setErorVisible(true);
                return false;
            }

        }
        else{
            if(companyNationalId.trim().length < 11){
                setErrorMessage("شناسه ملی شرکت، موسسه یا فروشگاه را وارد کنید");
                setErorVisible(true);
                return false;
            }
        }
        if(city == null){
            setErrorMessage("استان و شهر را مشحص کنید");
            setErorVisible(true);
            return false;
        }
        if(city.cityId < 10){
            setErrorMessage("استان و شهر را مشحص کنید");
            setErorVisible(true);
            return false;
        }
        return true;
    }
    const saveBuyCompanyInLocal = ()=>{
        var buyCompany = {
            isPersonal:isPersonal,
            personNationalId:personNationalId,
            economicCode:economicCode,
            companyNationalId:companyNationalId,
            title:title,
            city:city
        }
        util.saveBuyCompany(buyCompany);
    }
    const onContinueButtonClick = function(){
        if(!checkDataEntry()) return;
        setSaving(true);
        saveBuyCompanyInLocal();

        var b = util.isLogedInServer(setAsLoggedIn, setAsNotLoggedIn);
    }
    const setAsLoggedIn = function(){
        setSaving(false);
        console.log("is logged in");
        setRedirectUrl("/buy/product/summary")
    }
    const setAsNotLoggedIn = function(){
        setSaving(false);
            util.saveAfterLoginUrl("complete_buy_product");
            setRedirectUrl("/check-user-exist")
    }

    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px", position:"relative"}} ref={targetRef1}>                
                <Col className="d-flex justify-content-center align-items-center" style={{marginBottom:"150px"}}>
                    <Col md={3} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px", position:"relative"}}>
                        <img src={require("../lib/images/back.png")} alt='برگشت' onClick={()=>{navigate("/buy-product")}} style={{width:"48px", height:"32px", position:"absolute", top:"5px", right:"10px", cursor:"pointer"}} />
                        <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                            <tbody>
                                <tr>
                                    <td style={{width:"100%", textAlign:"center"}}>
                                        <img src={require('../lib/images/hana.webp')} style={{width:"64px"}} />
                                        {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.5em", textAlign:"center"}}>ثبت مشخصات شرکت، موسسه یا فروشگاه</td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                        <FloatLabel>
                                            <InputText value={title} onChange={(e)=>{onInputChange(e, "title")}} id="title" keyfilter="" maxLength={200} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                                            <label htmlFor="title">نام شرکت، موسسه یا فروشگاه</label>
                                        </FloatLabel>
                                        
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em"}}>
                                        <Row>
                                            <Col>
                                                <div className="flex align-items-center">
                                                    <RadioButton inputId="isPersonal" name="pizza" value={true} onChange={(e) => setIsPersonal(e.value)} checked={isPersonal === true} />
                                                    <label htmlFor="isPersonal" className="ml-2">&nbsp;&nbsp;حقیقی</label>
                                                </div>
                                            </Col>
                                            <Col>
                                            <div className="flex align-items-center">
                                                <RadioButton inputId="isCompany" name="pizza" value={false} onChange={(e) => setIsPersonal(e.value)} checked={isPersonal === false} />
                                                <label htmlFor="isCompany" className="ml-2">&nbsp;&nbsp;حقوقی</label>
                                            </div>
                                            </Col>
                                        </Row>
                                    </td>
                                </tr>
                                {
                                    isPersonal?
                                    <>
                                        <tr><td>&nbsp;</td></tr>
                                        <tr>
                                            <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                                <FloatLabel>
                                                    <InputText value={personNationalId} onChange={(e)=>{onInputChange(e, "personNationalId")}} id="personNationalId" onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} maxLength={12} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                                                    <label htmlFor="personNationalId">کد ملی</label>
                                                </FloatLabel>
                                                
                                            </td>
                                        </tr>
                                        <tr><td>&nbsp;</td></tr>
                                        <tr>
                                            <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                                <FloatLabel>
                                                    <InputText value={economicCode} onChange={(e)=>{onInputChange(e, "economicCode")}} id="economicCode" onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} maxLength={12} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                                                    <label htmlFor="economicCode">کد اقتصادی</label>
                                                </FloatLabel>
                                                
                                            </td>
                                        </tr>
                                    </>
                                    :
                                    <>
                                        <tr><td>&nbsp;</td></tr>
                                        <tr>
                                            <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                                <FloatLabel>
                                                    <InputText value={companyNationalId} onChange={(e)=>{onInputChange(e, "companyNationalId")}} id="companyNationalId" onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} maxLength={11} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                                                    <label htmlFor="companyNationalId">شناسه ملی</label>
                                                </FloatLabel>
                                                
                                            </td>
                                        </tr>
                                    </>
                                }
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                        <CityCombo horizontal={false} value={city} onChange={(value)=>{setCity(value);console.log("city is>", value)}} />
                                        
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                        <div className="flex justify-content-center" style={{ direction: "ltr" }}>
                                            <Button severity="success" onClick={()=>{onContinueButtonClick()}} style={{borderRadius:"5px"}} loading={saving} iconPos="right" icon="pi pi-check">&nbsp;&nbsp;تائید مشخصات و ادامه&nbsp;&nbsp;</Button>
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </Col>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}